import { c as _c } from "react/compiler-runtime";
import { Icon, Typography } from "@/shared/ui/atoms";
const EmptyHospitalKeywords = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex gap-1 justify-center items-center py-2 bg-gray-100 rounded-lg"><Icon src="/icons/search-eye-fill.svg" alt="tag" width={16} height={16} /><Typography size={12} className="text-gray-700">흩어진 병원 리뷰 모아보기</Typography></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default EmptyHospitalKeywords;